const WELCOME_GUIDE_STORAGE_PREFIX = "app_welcome_guide";
const WELCOME_GUIDE_STORAGE_VERSION = "v1";

const WELCOME_GUIDE_EXCLUDED_COMPONENTS = new Set([
  "settings/passwords/show",
  "settings/emails/show",
  "settings/sessions/index",
  "settings/api_keys/index",
]);

interface WelcomeGuideVisibilityParams {
  component: string;
  userId?: number | null;
  storage?: Storage;
}

function welcomeGuideStorageKey(userId: number): string {
  return `${WELCOME_GUIDE_STORAGE_PREFIX}:${WELCOME_GUIDE_STORAGE_VERSION}:${userId}`;
}

function resolveStorage(storage?: Storage): Storage | undefined {
  if (storage) return storage;
  if (typeof window === "undefined") return undefined;

  return window.localStorage;
}

export function isWelcomeGuideExcludedComponent(component: string): boolean {
  return WELCOME_GUIDE_EXCLUDED_COMPONENTS.has(component);
}

export function shouldShowWelcomeGuide({
  component,
  userId,
  storage,
}: WelcomeGuideVisibilityParams): boolean {
  if (!userId) return false;
  if (isWelcomeGuideExcludedComponent(component)) return false;

  const storageBackend = resolveStorage(storage);
  if (!storageBackend) return false;

  return storageBackend.getItem(welcomeGuideStorageKey(userId)) !== "1";
}

export function markWelcomeGuideDismissed(
  userId?: number | null,
  storage?: Storage,
): void {
  if (!userId) return;

  const storageBackend = resolveStorage(storage);
  if (!storageBackend) return;

  storageBackend.setItem(welcomeGuideStorageKey(userId), "1");
}
